
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _91_46_46_46slug_930lRyvnCQT7Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/[...slug].vue?macro=true";
import { default as _404bJLoc4lH2uMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/404.vue?macro=true";
import { default as clientsCQmsbHlRmhMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/b2bauth/clients.vue?macro=true";
import { default as _91id_93IThNiU6puqMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Banners/[id].vue?macro=true";
import { default as createttRnJxCI7jMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Banners/create.vue?macro=true";
import { default as indexsude6CyqVkMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Banners/index.vue?macro=true";
import { default as _91id_93RvJXfxD07MMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/categories/[id].vue?macro=true";
import { default as createGbgh8aoq2tMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/categories/create.vue?macro=true";
import { default as index0DLth2yo75Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/categories/index.vue?macro=true";
import { default as _91id_93GCYyHVR0Z3Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/keywords/[id].vue?macro=true";
import { default as create9IoMP5adIwMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/keywords/create.vue?macro=true";
import { default as index2iSL7vDHmXMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/keywords/index.vue?macro=true";
import { default as _91id_93zQsZshUqsWMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/posts/[id].vue?macro=true";
import { default as create0iu1H22PAhMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/posts/create.vue?macro=true";
import { default as indexzHvGiLiD5uMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/posts/index.vue?macro=true";
import { default as _91id_93nmdJJZi9XdMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/brands/[id].vue?macro=true";
import { default as createze5L262u1GMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/brands/create.vue?macro=true";
import { default as indexF7P6CbaeugMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/brands/index.vue?macro=true";
import { default as _91id_93fM3pwy0bcRMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/categories/[id].vue?macro=true";
import { default as CreaterrhUb5tiVjMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/categories/Create.vue?macro=true";
import { default as indexeZl0C4EkVfMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/categories/index.vue?macro=true";
import { default as index8bzaVqik15Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/combos/[id]/index.vue?macro=true";
import { default as create1gp3OqupyyMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/combos/create.vue?macro=true";
import { default as indexDd3BlrRHc9Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/combos/index.vue?macro=true";
import { default as indexUjvHYaRXdKMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Criterias/index.vue?macro=true";
import { default as indexvGjTrV7RgGMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Dispatch-orders/index.vue?macro=true";
import { default as createHlCk7bid8ZMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/invoices/create.vue?macro=true";
import { default as indexkTAWouR568Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/invoices/index.vue?macro=true";
import { default as index3ht2PTthGlMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Managers/index.vue?macro=true";
import { default as _91id_93sj8OKVFNGwMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Offers/[id].vue?macro=true";
import { default as CreatekUYQs2iPBwMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Offers/Create.vue?macro=true";
import { default as indexrSFX5qjKb5Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Offers/index.vue?macro=true";
import { default as indexG9gzAob1OUMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Orders/index.vue?macro=true";
import { default as editf8cW9bCB09Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/products/[slug]/edit.vue?macro=true";
import { default as Createn5ZaI8uCmNMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/products/Create.vue?macro=true";
import { default as index2ffGIPUW1MMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/products/index.vue?macro=true";
import { default as indexhJtl9vQKcaMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Reviews/index.vue?macro=true";
import { default as _91id_93Kiz4wFaiOUMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Roles/[id].vue?macro=true";
import { default as CreateB7aU8KhBdIMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Roles/Create.vue?macro=true";
import { default as indexQNgNxJo47JMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Roles/index.vue?macro=true";
import { default as CustomizationjASSkDYsCRMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Settings/Customization.vue?macro=true";
import { default as GeneralsHhOnKA0DYKMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Settings/Generals.vue?macro=true";
import { default as editW3FSCJf01XMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/[id]/edit.vue?macro=true";
import { default as managers1W4nA9UgXiMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/[id]/managers.vue?macro=true";
import { default as indexoBukVdgD47Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/balance/index.vue?macro=true";
import { default as create2ber9FhAv2Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/create.vue?macro=true";
import { default as indexdX41BF9VYeMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/index.vue?macro=true";
import { default as __91id_93fqgttJVTtrMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/settings/_[id].vue?macro=true";
import { default as customizationsbX34inI8q4Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/settings/customizations.vue?macro=true";
import { default as deliverySXCwBYH8T5Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/settings/delivery.vue?macro=true";
import { default as notificationsKTfYIZ513DMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/settings/notifications.vue?macro=true";
import { default as credentials0ibVELnYvRMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/stripe-proxy/credentials.vue?macro=true";
import { default as transactionsZoBRlGJvNjMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/stripe-proxy/transactions.vue?macro=true";
import { default as showZfUnrhlcviMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Suborders/[suborder]/show.vue?macro=true";
import { default as indexPEGcJLG3bDMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Suborders/index.vue?macro=true";
import { default as _91id_93ApMrDfxsgWMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Users/[id].vue?macro=true";
import { default as createIPc5wZl9hzMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Users/create.vue?macro=true";
import { default as indexwMSfnPGmzwMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Users/index.vue?macro=true";
import { default as index87II47SLjSMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/withdraw-requests/index.vue?macro=true";
import { default as ConfirmPasswordQxK9Oaful8Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/ConfirmPassword.vue?macro=true";
import { default as ForgotPasswordoeb9uIboL0Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/ForgotPassword.vue?macro=true";
import { default as Login1rNdz4mZxXMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/Login.vue?macro=true";
import { default as RegistercZcRkaL8hlMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/Register.vue?macro=true";
import { default as ResetPasswordMzkUnJxPvvMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/ResetPassword.vue?macro=true";
import { default as VerifyEmailQe9Vgt3aUaMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/VerifyEmail.vue?macro=true";
import { default as _91blog_933Nc31gY2LDMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/blog/[blog].vue?macro=true";
import { default as index3PsxwGTTRKMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/blog/index.vue?macro=true";
import { default as indexRHGsbAQKDrMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Cart/index.vue?macro=true";
import { default as _91combo_93MtQZkYfsHVMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Combos/[combo].vue?macro=true";
import { default as indexjkxh2sRdm8Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/comprar-en-cuba-desde-espana/index.vue?macro=true";
import { default as indexVdTTvg4CFtMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/comprar-en-cuba-desde-miami/index.vue?macro=true";
import { default as indeximvWV6IyPvMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/comprar-en-cuba-desde-otros-paises/index.vue?macro=true";
import { default as index6jSJo3szkvMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/comprar-en-cuba-online/index.vue?macro=true";
import { default as indexwOg3LvJxivMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Contact-Us/index.vue?macro=true";
import { default as indexcNNkp51kpbMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/index.vue?macro=true";
import { default as infoOe3QZgKWlUMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/info.vue?macro=true";
import { default as _91InformationPage_93GSkxgsp9KqMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/information/[InformationPage].vue?macro=true";
import { default as cookie_45policyumFFKPN5JDMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/information/cookie-policy.vue?macro=true";
import { default as indexgK4MEd9S6VMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/mayorista/index.vue?macro=true";
import { default as indexAX4zByc2LcMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Offers/index.vue?macro=true";
import { default as redirect_45pagepcd3BN2QcvMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Orders/[order]/redirect-page.vue?macro=true";
import { default as showE9uYW6WenvMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Orders/[order]/show.vue?macro=true";
import { default as CreateiSASxxCWLBMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Orders/Create.vue?macro=true";
import { default as success_45pageo4La1IBjUtMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Orders/success-page.vue?macro=true";
import { default as _91id_93MRfu3H9UkpMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/payment_shopping_card/[id].vue?macro=true";
import { default as _91product_93l2BRKsmKFEMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/[product].vue?macro=true";
import { default as AcceptReview0RSUOXdvt9Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/AcceptReview.vue?macro=true";
import { default as ReadReviewiDt3sKpfUeMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/ReadReview.vue?macro=true";
import { default as _91product_93ZVx3GAmc2NMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/Review/Read/[product].vue?macro=true";
import { default as _91product_93aRMBxs66pnMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/Review/Write/[product].vue?macro=true";
import { default as SuccessPageyAnhgBapHzMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/SuccessPage.vue?macro=true";
import { default as WriteReviewd9oid4tDAzMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/WriteReview.vue?macro=true";
import { default as indexUya8FTZ3euMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Beneficiaries/index.vue?macro=true";
import { default as index0mz3Jr6Z68Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Favorites/index.vue?macro=true";
import { default as indexiR7O0iZSJQMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/index.vue?macro=true";
import { default as indexOfwzNeTQA4Meta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Orders/index.vue?macro=true";
import { default as _91id_93DrhDvx00xJMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Shopping_Card/[id].vue?macro=true";
import { default as indexlTXVjNoudVMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Shopping_Card/index.vue?macro=true";
import { default as _91id_93xar54CbWwDMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Shopping_Card/recharge/[id].vue?macro=true";
import { default as index1NGmrdktChMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/shopping_card/index.vue?macro=true";
import { default as _91store_93jT1jIJUyQJMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Store/[store].vue?macro=true";
import { default as indexTPWUirAv2eMeta } from "/var/www/marketplace-dev.ingeniuscloud.net/pages/Store/index.vue?macro=true";
export default [
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/[...slug].vue")
  },
  {
    name: "slug___es",
    path: "/:slug(.*)*",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/[...slug].vue")
  },
  {
    name: "404___en",
    path: "/en/404",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/404.vue")
  },
  {
    name: "404___es",
    path: "/404",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/404.vue")
  },
  {
    name: "Admin-b2bauth-clients___en",
    path: "/en/Admin/b2bauth/clients",
    meta: clientsCQmsbHlRmhMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/b2bauth/clients.vue")
  },
  {
    name: "Admin-b2bauth-clients___es",
    path: "/Admin/b2bauth/clients",
    meta: clientsCQmsbHlRmhMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/b2bauth/clients.vue")
  },
  {
    name: "Admin-Banners-id___en",
    path: "/en/Admin/Banners/:id()",
    meta: _91id_93IThNiU6puqMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Banners/[id].vue")
  },
  {
    name: "Admin-Banners-id___es",
    path: "/Admin/Banners/:id()",
    meta: _91id_93IThNiU6puqMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Banners/[id].vue")
  },
  {
    name: "Admin-Banners-create___en",
    path: "/en/Admin/Banners/create",
    meta: createttRnJxCI7jMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Banners/create.vue")
  },
  {
    name: "Admin-Banners-create___es",
    path: "/Admin/Banners/create",
    meta: createttRnJxCI7jMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Banners/create.vue")
  },
  {
    name: "Admin-Banners___en",
    path: "/en/Admin/Banners",
    meta: indexsude6CyqVkMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Banners/index.vue")
  },
  {
    name: "Admin-Banners___es",
    path: "/Admin/Banners",
    meta: indexsude6CyqVkMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Banners/index.vue")
  },
  {
    name: "Admin-blogs-categories-id___en",
    path: "/en/Admin/blogs/categories/:id()",
    meta: _91id_93RvJXfxD07MMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/categories/[id].vue")
  },
  {
    name: "Admin-blogs-categories-id___es",
    path: "/Admin/blogs/categories/:id()",
    meta: _91id_93RvJXfxD07MMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/categories/[id].vue")
  },
  {
    name: "Admin-blogs-categories-create___en",
    path: "/en/Admin/blogs/categories/create",
    meta: createGbgh8aoq2tMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/categories/create.vue")
  },
  {
    name: "Admin-blogs-categories-create___es",
    path: "/Admin/blogs/categories/create",
    meta: createGbgh8aoq2tMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/categories/create.vue")
  },
  {
    name: "Admin-blogs-categories___en",
    path: "/en/Admin/blogs/categories",
    meta: index0DLth2yo75Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/categories/index.vue")
  },
  {
    name: "Admin-blogs-categories___es",
    path: "/Admin/blogs/categories",
    meta: index0DLth2yo75Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/categories/index.vue")
  },
  {
    name: "Admin-blogs-keywords-id___en",
    path: "/en/Admin/blogs/keywords/:id()",
    meta: _91id_93GCYyHVR0Z3Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/keywords/[id].vue")
  },
  {
    name: "Admin-blogs-keywords-id___es",
    path: "/Admin/blogs/keywords/:id()",
    meta: _91id_93GCYyHVR0Z3Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/keywords/[id].vue")
  },
  {
    name: "Admin-blogs-keywords-create___en",
    path: "/en/Admin/blogs/keywords/create",
    meta: create9IoMP5adIwMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/keywords/create.vue")
  },
  {
    name: "Admin-blogs-keywords-create___es",
    path: "/Admin/blogs/keywords/create",
    meta: create9IoMP5adIwMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/keywords/create.vue")
  },
  {
    name: "Admin-blogs-keywords___en",
    path: "/en/Admin/blogs/keywords",
    meta: index2iSL7vDHmXMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/keywords/index.vue")
  },
  {
    name: "Admin-blogs-keywords___es",
    path: "/Admin/blogs/keywords",
    meta: index2iSL7vDHmXMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/keywords/index.vue")
  },
  {
    name: "Admin-blogs-posts-id___en",
    path: "/en/Admin/blogs/posts/:id()",
    meta: _91id_93zQsZshUqsWMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/posts/[id].vue")
  },
  {
    name: "Admin-blogs-posts-id___es",
    path: "/Admin/blogs/posts/:id()",
    meta: _91id_93zQsZshUqsWMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/posts/[id].vue")
  },
  {
    name: "Admin-blogs-posts-create___en",
    path: "/en/Admin/blogs/posts/create",
    meta: create0iu1H22PAhMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/posts/create.vue")
  },
  {
    name: "Admin-blogs-posts-create___es",
    path: "/Admin/blogs/posts/create",
    meta: create0iu1H22PAhMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/posts/create.vue")
  },
  {
    name: "Admin-blogs-posts___en",
    path: "/en/Admin/blogs/posts",
    meta: indexzHvGiLiD5uMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/posts/index.vue")
  },
  {
    name: "Admin-blogs-posts___es",
    path: "/Admin/blogs/posts",
    meta: indexzHvGiLiD5uMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/blogs/posts/index.vue")
  },
  {
    name: "Admin-brands-id___en",
    path: "/en/Admin/brands/:id()",
    meta: _91id_93nmdJJZi9XdMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/brands/[id].vue")
  },
  {
    name: "Admin-brands-id___es",
    path: "/Admin/brands/:id()",
    meta: _91id_93nmdJJZi9XdMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/brands/[id].vue")
  },
  {
    name: "Admin-brands-create___en",
    path: "/en/Admin/brands/create",
    meta: createze5L262u1GMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/brands/create.vue")
  },
  {
    name: "Admin-brands-create___es",
    path: "/Admin/brands/create",
    meta: createze5L262u1GMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/brands/create.vue")
  },
  {
    name: "Admin-brands___en",
    path: "/en/Admin/brands",
    meta: indexF7P6CbaeugMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/brands/index.vue")
  },
  {
    name: "Admin-brands___es",
    path: "/Admin/brands",
    meta: indexF7P6CbaeugMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/brands/index.vue")
  },
  {
    name: "Admin-categories-id___en",
    path: "/en/Admin/categories/:id()",
    meta: _91id_93fM3pwy0bcRMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/categories/[id].vue")
  },
  {
    name: "Admin-categories-id___es",
    path: "/Admin/categories/:id()",
    meta: _91id_93fM3pwy0bcRMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/categories/[id].vue")
  },
  {
    name: "Admin-categories-Create___en",
    path: "/en/Admin/categories/Create",
    meta: CreaterrhUb5tiVjMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/categories/Create.vue")
  },
  {
    name: "Admin-categories-Create___es",
    path: "/Admin/categories/Create",
    meta: CreaterrhUb5tiVjMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/categories/Create.vue")
  },
  {
    name: "Admin-categories___en",
    path: "/en/Admin/categories",
    meta: indexeZl0C4EkVfMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/categories/index.vue")
  },
  {
    name: "Admin-categories___es",
    path: "/Admin/categories",
    meta: indexeZl0C4EkVfMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/categories/index.vue")
  },
  {
    name: "Admin-combos-id___en",
    path: "/en/Admin/combos/:id()",
    meta: index8bzaVqik15Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/combos/[id]/index.vue")
  },
  {
    name: "Admin-combos-id___es",
    path: "/Admin/combos/:id()",
    meta: index8bzaVqik15Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/combos/[id]/index.vue")
  },
  {
    name: "Admin-combos-create___en",
    path: "/en/Admin/combos/create",
    meta: create1gp3OqupyyMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/combos/create.vue")
  },
  {
    name: "Admin-combos-create___es",
    path: "/Admin/combos/create",
    meta: create1gp3OqupyyMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/combos/create.vue")
  },
  {
    name: "Admin-combos___en",
    path: "/en/Admin/combos",
    meta: indexDd3BlrRHc9Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/combos/index.vue")
  },
  {
    name: "Admin-combos___es",
    path: "/Admin/combos",
    meta: indexDd3BlrRHc9Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/combos/index.vue")
  },
  {
    name: "Admin-Criterias___en",
    path: "/en/Admin/Criterias",
    meta: indexUjvHYaRXdKMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Criterias/index.vue")
  },
  {
    name: "Admin-Criterias___es",
    path: "/Admin/Criterias",
    meta: indexUjvHYaRXdKMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Criterias/index.vue")
  },
  {
    name: "Admin-Dispatch-orders___en",
    path: "/en/Admin/Dispatch-orders",
    meta: indexvGjTrV7RgGMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Dispatch-orders/index.vue")
  },
  {
    name: "Admin-Dispatch-orders___es",
    path: "/Admin/Dispatch-orders",
    meta: indexvGjTrV7RgGMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Dispatch-orders/index.vue")
  },
  {
    name: "Admin-invoices-create___en",
    path: "/en/Admin/invoices/create",
    meta: createHlCk7bid8ZMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/invoices/create.vue")
  },
  {
    name: "Admin-invoices-create___es",
    path: "/Admin/invoices/create",
    meta: createHlCk7bid8ZMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/invoices/create.vue")
  },
  {
    name: "Admin-invoices___en",
    path: "/en/Admin/invoices",
    meta: indexkTAWouR568Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/invoices/index.vue")
  },
  {
    name: "Admin-invoices___es",
    path: "/Admin/invoices",
    meta: indexkTAWouR568Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/invoices/index.vue")
  },
  {
    name: "Admin-Managers___en",
    path: "/en/Admin/Managers",
    meta: index3ht2PTthGlMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Managers/index.vue")
  },
  {
    name: "Admin-Managers___es",
    path: "/Admin/Managers",
    meta: index3ht2PTthGlMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Managers/index.vue")
  },
  {
    name: "Admin-Offers-id___en",
    path: "/en/Admin/Offers/:id()",
    meta: _91id_93sj8OKVFNGwMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Offers/[id].vue")
  },
  {
    name: "Admin-Offers-id___es",
    path: "/Admin/Offers/:id()",
    meta: _91id_93sj8OKVFNGwMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Offers/[id].vue")
  },
  {
    name: "Admin-Offers-Create___en",
    path: "/en/Admin/Offers/Create",
    meta: CreatekUYQs2iPBwMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Offers/Create.vue")
  },
  {
    name: "Admin-Offers-Create___es",
    path: "/Admin/Offers/Create",
    meta: CreatekUYQs2iPBwMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Offers/Create.vue")
  },
  {
    name: "Admin-Offers___en",
    path: "/en/Admin/Offers",
    meta: indexrSFX5qjKb5Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Offers/index.vue")
  },
  {
    name: "Admin-Offers___es",
    path: "/Admin/Offers",
    meta: indexrSFX5qjKb5Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Offers/index.vue")
  },
  {
    name: "Admin-Orders___en",
    path: "/en/Admin/Orders",
    meta: indexG9gzAob1OUMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Orders/index.vue")
  },
  {
    name: "Admin-Orders___es",
    path: "/Admin/Orders",
    meta: indexG9gzAob1OUMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Orders/index.vue")
  },
  {
    name: "Admin-products-slug-edit___en",
    path: "/en/Admin/products/:slug()/edit",
    meta: editf8cW9bCB09Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/products/[slug]/edit.vue")
  },
  {
    name: "Admin-products-slug-edit___es",
    path: "/Admin/products/:slug()/edit",
    meta: editf8cW9bCB09Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/products/[slug]/edit.vue")
  },
  {
    name: "Admin-products-Create___en",
    path: "/en/Admin/products/Create",
    meta: Createn5ZaI8uCmNMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/products/Create.vue")
  },
  {
    name: "Admin-products-Create___es",
    path: "/Admin/products/Create",
    meta: Createn5ZaI8uCmNMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/products/Create.vue")
  },
  {
    name: "Admin-products___en",
    path: "/en/Admin/products",
    meta: index2ffGIPUW1MMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/products/index.vue")
  },
  {
    name: "Admin-products___es",
    path: "/Admin/products",
    meta: index2ffGIPUW1MMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/products/index.vue")
  },
  {
    name: "Admin-Reviews___en",
    path: "/en/Admin/Reviews",
    meta: indexhJtl9vQKcaMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Reviews/index.vue")
  },
  {
    name: "Admin-Reviews___es",
    path: "/Admin/Reviews",
    meta: indexhJtl9vQKcaMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Reviews/index.vue")
  },
  {
    name: "Admin-Roles-id___en",
    path: "/en/Admin/Roles/:id()",
    meta: _91id_93Kiz4wFaiOUMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Roles/[id].vue")
  },
  {
    name: "Admin-Roles-id___es",
    path: "/Admin/Roles/:id()",
    meta: _91id_93Kiz4wFaiOUMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Roles/[id].vue")
  },
  {
    name: "Admin-Roles-Create___en",
    path: "/en/Admin/Roles/Create",
    meta: CreateB7aU8KhBdIMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Roles/Create.vue")
  },
  {
    name: "Admin-Roles-Create___es",
    path: "/Admin/Roles/Create",
    meta: CreateB7aU8KhBdIMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Roles/Create.vue")
  },
  {
    name: "Admin-Roles___en",
    path: "/en/Admin/Roles",
    meta: indexQNgNxJo47JMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Roles/index.vue")
  },
  {
    name: "Admin-Roles___es",
    path: "/Admin/Roles",
    meta: indexQNgNxJo47JMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Roles/index.vue")
  },
  {
    name: "Admin-Settings-Customization___en",
    path: "/en/Admin/Settings/Customization",
    meta: CustomizationjASSkDYsCRMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Settings/Customization.vue")
  },
  {
    name: "Admin-Settings-Customization___es",
    path: "/Admin/Settings/Customization",
    meta: CustomizationjASSkDYsCRMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Settings/Customization.vue")
  },
  {
    name: "Admin-Settings-Generals___en",
    path: "/en/Admin/Settings/Generals",
    meta: GeneralsHhOnKA0DYKMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Settings/Generals.vue")
  },
  {
    name: "Admin-Settings-Generals___es",
    path: "/Admin/Settings/Generals",
    meta: GeneralsHhOnKA0DYKMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Settings/Generals.vue")
  },
  {
    name: "Admin-Stores-id-edit___en",
    path: "/en/Admin/Stores/:id()/edit",
    meta: editW3FSCJf01XMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/[id]/edit.vue")
  },
  {
    name: "Admin-Stores-id-edit___es",
    path: "/Admin/Stores/:id()/edit",
    meta: editW3FSCJf01XMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/[id]/edit.vue")
  },
  {
    name: "Admin-Stores-id-managers___en",
    path: "/en/Admin/Stores/:id()/managers",
    meta: managers1W4nA9UgXiMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/[id]/managers.vue")
  },
  {
    name: "Admin-Stores-id-managers___es",
    path: "/Admin/Stores/:id()/managers",
    meta: managers1W4nA9UgXiMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/[id]/managers.vue")
  },
  {
    name: "Admin-Stores-balance___en",
    path: "/en/Admin/Stores/balance",
    meta: indexoBukVdgD47Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/balance/index.vue")
  },
  {
    name: "Admin-Stores-balance___es",
    path: "/Admin/Stores/balance",
    meta: indexoBukVdgD47Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/balance/index.vue")
  },
  {
    name: "Admin-Stores-create___en",
    path: "/en/Admin/Stores/create",
    meta: create2ber9FhAv2Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/create.vue")
  },
  {
    name: "Admin-Stores-create___es",
    path: "/Admin/Stores/create",
    meta: create2ber9FhAv2Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/create.vue")
  },
  {
    name: "Admin-Stores___en",
    path: "/en/Admin/Stores",
    meta: indexdX41BF9VYeMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/index.vue")
  },
  {
    name: "Admin-Stores___es",
    path: "/Admin/Stores",
    meta: indexdX41BF9VYeMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/index.vue")
  },
  {
    name: "Admin-Stores-settings-_id___en",
    path: "/en/Admin/Stores/settings/_:id()",
    meta: __91id_93fqgttJVTtrMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/settings/_[id].vue")
  },
  {
    name: "Admin-Stores-settings-_id___es",
    path: "/Admin/Stores/settings/_:id()",
    meta: __91id_93fqgttJVTtrMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/settings/_[id].vue")
  },
  {
    name: "Admin-Stores-settings-customizations___en",
    path: "/en/Admin/Stores/settings/customizations",
    meta: customizationsbX34inI8q4Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/settings/customizations.vue")
  },
  {
    name: "Admin-Stores-settings-customizations___es",
    path: "/Admin/Stores/settings/customizations",
    meta: customizationsbX34inI8q4Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/settings/customizations.vue")
  },
  {
    name: "Admin-Stores-settings-delivery___en",
    path: "/en/Admin/Stores/settings/delivery",
    meta: deliverySXCwBYH8T5Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/settings/delivery.vue")
  },
  {
    name: "Admin-Stores-settings-delivery___es",
    path: "/Admin/Stores/settings/delivery",
    meta: deliverySXCwBYH8T5Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/settings/delivery.vue")
  },
  {
    name: "Admin-Stores-settings-notifications___en",
    path: "/en/Admin/Stores/settings/notifications",
    meta: notificationsKTfYIZ513DMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/settings/notifications.vue")
  },
  {
    name: "Admin-Stores-settings-notifications___es",
    path: "/Admin/Stores/settings/notifications",
    meta: notificationsKTfYIZ513DMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Stores/settings/notifications.vue")
  },
  {
    name: "Admin-stripe-proxy-credentials___en",
    path: "/en/Admin/stripe-proxy/credentials",
    meta: credentials0ibVELnYvRMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/stripe-proxy/credentials.vue")
  },
  {
    name: "Admin-stripe-proxy-credentials___es",
    path: "/Admin/stripe-proxy/credentials",
    meta: credentials0ibVELnYvRMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/stripe-proxy/credentials.vue")
  },
  {
    name: "Admin-stripe-proxy-transactions___en",
    path: "/en/Admin/stripe-proxy/transactions",
    meta: transactionsZoBRlGJvNjMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/stripe-proxy/transactions.vue")
  },
  {
    name: "Admin-stripe-proxy-transactions___es",
    path: "/Admin/stripe-proxy/transactions",
    meta: transactionsZoBRlGJvNjMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/stripe-proxy/transactions.vue")
  },
  {
    name: "Admin-Suborders-suborder-show___en",
    path: "/en/Admin/Suborders/:suborder()/show",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Suborders/[suborder]/show.vue")
  },
  {
    name: "Admin-Suborders-suborder-show___es",
    path: "/Admin/Suborders/:suborder()/show",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Suborders/[suborder]/show.vue")
  },
  {
    name: "Admin-Suborders___en",
    path: "/en/Admin/Suborders",
    meta: indexPEGcJLG3bDMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Suborders/index.vue")
  },
  {
    name: "Admin-Suborders___es",
    path: "/Admin/Suborders",
    meta: indexPEGcJLG3bDMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Suborders/index.vue")
  },
  {
    name: "Admin-Users-id___en",
    path: "/en/Admin/Users/:id()",
    meta: _91id_93ApMrDfxsgWMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Users/[id].vue")
  },
  {
    name: "Admin-Users-id___es",
    path: "/Admin/Users/:id()",
    meta: _91id_93ApMrDfxsgWMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Users/[id].vue")
  },
  {
    name: "Admin-Users-create___en",
    path: "/en/Admin/Users/create",
    meta: createIPc5wZl9hzMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Users/create.vue")
  },
  {
    name: "Admin-Users-create___es",
    path: "/Admin/Users/create",
    meta: createIPc5wZl9hzMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Users/create.vue")
  },
  {
    name: "Admin-Users___en",
    path: "/en/Admin/Users",
    meta: indexwMSfnPGmzwMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Users/index.vue")
  },
  {
    name: "Admin-Users___es",
    path: "/Admin/Users",
    meta: indexwMSfnPGmzwMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/Users/index.vue")
  },
  {
    name: "Admin-withdraw-requests___en",
    path: "/en/Admin/withdraw-requests",
    meta: index87II47SLjSMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/withdraw-requests/index.vue")
  },
  {
    name: "Admin-withdraw-requests___es",
    path: "/Admin/withdraw-requests",
    meta: index87II47SLjSMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Admin/withdraw-requests/index.vue")
  },
  {
    name: "Auth-ConfirmPassword___en",
    path: "/en/Auth/ConfirmPassword",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/ConfirmPassword.vue")
  },
  {
    name: "Auth-ConfirmPassword___es",
    path: "/Auth/ConfirmPassword",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/ConfirmPassword.vue")
  },
  {
    name: "Auth-ForgotPassword___en",
    path: "/en/Auth/ForgotPassword",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/ForgotPassword.vue")
  },
  {
    name: "Auth-ForgotPassword___es",
    path: "/Auth/ForgotPassword",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/ForgotPassword.vue")
  },
  {
    name: "Auth-Login___en",
    path: "/en/Auth/Login",
    meta: Login1rNdz4mZxXMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/Login.vue")
  },
  {
    name: "Auth-Login___es",
    path: "/Auth/Login",
    meta: Login1rNdz4mZxXMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/Login.vue")
  },
  {
    name: "Auth-Register___en",
    path: "/en/Auth/Register",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/Register.vue")
  },
  {
    name: "Auth-Register___es",
    path: "/Auth/Register",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/Register.vue")
  },
  {
    name: "Auth-ResetPassword___en",
    path: "/en/Auth/ResetPassword",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/ResetPassword.vue")
  },
  {
    name: "Auth-ResetPassword___es",
    path: "/Auth/ResetPassword",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/ResetPassword.vue")
  },
  {
    name: "Auth-VerifyEmail___en",
    path: "/en/Auth/VerifyEmail",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/VerifyEmail.vue")
  },
  {
    name: "Auth-VerifyEmail___es",
    path: "/Auth/VerifyEmail",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Auth/VerifyEmail.vue")
  },
  {
    name: "blog-blog___en",
    path: "/en/blog/:blog()",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/blog/[blog].vue")
  },
  {
    name: "blog-blog___es",
    path: "/blog/:blog()",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/blog/[blog].vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/blog/index.vue")
  },
  {
    name: "blog___es",
    path: "/blog",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/blog/index.vue")
  },
  {
    name: "Cart___en",
    path: "/en/Cart",
    meta: indexRHGsbAQKDrMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Cart/index.vue")
  },
  {
    name: "Cart___es",
    path: "/Cart",
    meta: indexRHGsbAQKDrMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Cart/index.vue")
  },
  {
    name: "Combos-combo___en",
    path: "/en/Combos/:combo()",
    meta: _91combo_93MtQZkYfsHVMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Combos/[combo].vue")
  },
  {
    name: "Combos-combo___es",
    path: "/Combos/:combo()",
    meta: _91combo_93MtQZkYfsHVMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Combos/[combo].vue")
  },
  {
    name: "comprar-en-cuba-desde-espana___en",
    path: "/en/comprar-en-cuba-desde-espana",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/comprar-en-cuba-desde-espana/index.vue")
  },
  {
    name: "comprar-en-cuba-desde-espana___es",
    path: "/comprar-en-cuba-desde-espana",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/comprar-en-cuba-desde-espana/index.vue")
  },
  {
    name: "comprar-en-cuba-desde-miami___en",
    path: "/en/comprar-en-cuba-desde-miami",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/comprar-en-cuba-desde-miami/index.vue")
  },
  {
    name: "comprar-en-cuba-desde-miami___es",
    path: "/comprar-en-cuba-desde-miami",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/comprar-en-cuba-desde-miami/index.vue")
  },
  {
    name: "comprar-en-cuba-desde-otros-paises___en",
    path: "/en/comprar-en-cuba-desde-otros-paises",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/comprar-en-cuba-desde-otros-paises/index.vue")
  },
  {
    name: "comprar-en-cuba-desde-otros-paises___es",
    path: "/comprar-en-cuba-desde-otros-paises",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/comprar-en-cuba-desde-otros-paises/index.vue")
  },
  {
    name: "comprar-en-cuba-online___en",
    path: "/en/comprar-en-cuba-online",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/comprar-en-cuba-online/index.vue")
  },
  {
    name: "comprar-en-cuba-online___es",
    path: "/comprar-en-cuba-online",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/comprar-en-cuba-online/index.vue")
  },
  {
    name: "Contact-Us___en",
    path: "/en/Contact-Us",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Contact-Us/index.vue")
  },
  {
    name: "Contact-Us___es",
    path: "/Contact-Us",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Contact-Us/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/index.vue")
  },
  {
    name: "info___en",
    path: "/en/info",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/info.vue")
  },
  {
    name: "info___es",
    path: "/info",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/info.vue")
  },
  {
    name: "information-InformationPage___en",
    path: "/en/information/:InformationPage()",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/information/[InformationPage].vue")
  },
  {
    name: "information-InformationPage___es",
    path: "/information/:InformationPage()",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/information/[InformationPage].vue")
  },
  {
    name: "information-cookie-policy___en",
    path: "/en/information/cookie-policy",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/information/cookie-policy.vue")
  },
  {
    name: "information-cookie-policy___es",
    path: "/information/cookie-policy",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/information/cookie-policy.vue")
  },
  {
    name: "mayorista___en",
    path: "/en/mayorista",
    meta: indexgK4MEd9S6VMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/mayorista/index.vue")
  },
  {
    name: "mayorista___es",
    path: "/mayorista",
    meta: indexgK4MEd9S6VMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/mayorista/index.vue")
  },
  {
    name: "Offers___en",
    path: "/en/Offers",
    meta: indexAX4zByc2LcMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Offers/index.vue")
  },
  {
    name: "Offers___es",
    path: "/Offers",
    meta: indexAX4zByc2LcMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Offers/index.vue")
  },
  {
    name: "Orders-order-redirect-page___en",
    path: "/en/Orders/:order()/redirect-page",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Orders/[order]/redirect-page.vue")
  },
  {
    name: "Orders-order-redirect-page___es",
    path: "/Orders/:order()/redirect-page",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Orders/[order]/redirect-page.vue")
  },
  {
    name: "Orders-order-show___en",
    path: "/en/Orders/:order()/show",
    meta: showE9uYW6WenvMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Orders/[order]/show.vue")
  },
  {
    name: "Orders-order-show___es",
    path: "/Orders/:order()/show",
    meta: showE9uYW6WenvMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Orders/[order]/show.vue")
  },
  {
    name: "Orders-Create___en",
    path: "/en/Orders/Create",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Orders/Create.vue")
  },
  {
    name: "Orders-Create___es",
    path: "/Orders/Create",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Orders/Create.vue")
  },
  {
    name: "Orders-success-page___en",
    path: "/en/Orders/success-page",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Orders/success-page.vue")
  },
  {
    name: "Orders-success-page___es",
    path: "/Orders/success-page",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Orders/success-page.vue")
  },
  {
    name: "payment_shopping_card-id___en",
    path: "/en/payment_shopping_card/:id()",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/payment_shopping_card/[id].vue")
  },
  {
    name: "payment_shopping_card-id___es",
    path: "/payment_shopping_card/:id()",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/payment_shopping_card/[id].vue")
  },
  {
    name: "Products-product___en",
    path: "/en/Products/:product()",
    meta: _91product_93l2BRKsmKFEMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/[product].vue")
  },
  {
    name: "Products-product___es",
    path: "/Products/:product()",
    meta: _91product_93l2BRKsmKFEMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/[product].vue")
  },
  {
    name: "Products-AcceptReview___en",
    path: "/en/Products/AcceptReview",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/AcceptReview.vue")
  },
  {
    name: "Products-AcceptReview___es",
    path: "/Products/AcceptReview",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/AcceptReview.vue")
  },
  {
    name: "Products-ReadReview___en",
    path: "/en/Products/ReadReview",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/ReadReview.vue")
  },
  {
    name: "Products-ReadReview___es",
    path: "/Products/ReadReview",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/ReadReview.vue")
  },
  {
    name: "Products-Review-Read-product___en",
    path: "/en/Products/Review/Read/:product()",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/Review/Read/[product].vue")
  },
  {
    name: "Products-Review-Read-product___es",
    path: "/Products/Review/Read/:product()",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/Review/Read/[product].vue")
  },
  {
    name: "Products-Review-Write-product___en",
    path: "/en/Products/Review/Write/:product()",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/Review/Write/[product].vue")
  },
  {
    name: "Products-Review-Write-product___es",
    path: "/Products/Review/Write/:product()",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/Review/Write/[product].vue")
  },
  {
    name: "Products-SuccessPage___en",
    path: "/en/Products/SuccessPage",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/SuccessPage.vue")
  },
  {
    name: "Products-SuccessPage___es",
    path: "/Products/SuccessPage",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/SuccessPage.vue")
  },
  {
    name: "Products-WriteReview___en",
    path: "/en/Products/WriteReview",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/WriteReview.vue")
  },
  {
    name: "Products-WriteReview___es",
    path: "/Products/WriteReview",
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Products/WriteReview.vue")
  },
  {
    name: "Profile-Beneficiaries___en",
    path: "/en/Profile/Beneficiaries",
    meta: indexUya8FTZ3euMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Beneficiaries/index.vue")
  },
  {
    name: "Profile-Beneficiaries___es",
    path: "/Profile/Beneficiaries",
    meta: indexUya8FTZ3euMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Beneficiaries/index.vue")
  },
  {
    name: "Profile-Favorites___en",
    path: "/en/Profile/Favorites",
    meta: index0mz3Jr6Z68Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Favorites/index.vue")
  },
  {
    name: "Profile-Favorites___es",
    path: "/Profile/Favorites",
    meta: index0mz3Jr6Z68Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Favorites/index.vue")
  },
  {
    name: "Profile___en",
    path: "/en/Profile",
    meta: indexiR7O0iZSJQMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/index.vue")
  },
  {
    name: "Profile___es",
    path: "/Profile",
    meta: indexiR7O0iZSJQMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/index.vue")
  },
  {
    name: "Profile-Orders___en",
    path: "/en/Profile/Orders",
    meta: indexOfwzNeTQA4Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Orders/index.vue")
  },
  {
    name: "Profile-Orders___es",
    path: "/Profile/Orders",
    meta: indexOfwzNeTQA4Meta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Orders/index.vue")
  },
  {
    name: "Profile-Shopping_Card-id___en",
    path: "/en/Profile/Shopping_Card/:id()",
    meta: _91id_93DrhDvx00xJMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Shopping_Card/[id].vue")
  },
  {
    name: "Profile-Shopping_Card-id___es",
    path: "/Profile/Shopping_Card/:id()",
    meta: _91id_93DrhDvx00xJMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Shopping_Card/[id].vue")
  },
  {
    name: "Profile-Shopping_Card___en",
    path: "/en/Profile/Shopping_Card",
    meta: indexlTXVjNoudVMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Shopping_Card/index.vue")
  },
  {
    name: "Profile-Shopping_Card___es",
    path: "/Profile/Shopping_Card",
    meta: indexlTXVjNoudVMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Shopping_Card/index.vue")
  },
  {
    name: "Profile-Shopping_Card-recharge-id___en",
    path: "/en/Profile/Shopping_Card/recharge/:id()",
    meta: _91id_93xar54CbWwDMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Shopping_Card/recharge/[id].vue")
  },
  {
    name: "Profile-Shopping_Card-recharge-id___es",
    path: "/Profile/Shopping_Card/recharge/:id()",
    meta: _91id_93xar54CbWwDMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Profile/Shopping_Card/recharge/[id].vue")
  },
  {
    name: "shopping_card___en",
    path: "/en/shopping_card",
    meta: index1NGmrdktChMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/shopping_card/index.vue")
  },
  {
    name: "shopping_card___es",
    path: "/shopping_card",
    meta: index1NGmrdktChMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/shopping_card/index.vue")
  },
  {
    name: "Store-store___en",
    path: "/en/Store/:store()",
    meta: _91store_93jT1jIJUyQJMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Store/[store].vue")
  },
  {
    name: "Store-store___es",
    path: "/Store/:store()",
    meta: _91store_93jT1jIJUyQJMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Store/[store].vue")
  },
  {
    name: "Store___en",
    path: "/en/Store",
    meta: indexTPWUirAv2eMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Store/index.vue")
  },
  {
    name: "Store___es",
    path: "/Store",
    meta: indexTPWUirAv2eMeta || {},
    component: () => import("/var/www/marketplace-dev.ingeniuscloud.net/pages/Store/index.vue")
  }
]